import { render, staticRenderFns } from "./DesktopComponent.vue?vue&type=template&id=1beff330&scoped=true&"
import script from "./DesktopComponent.vue?vue&type=script&lang=js&"
export * from "./DesktopComponent.vue?vue&type=script&lang=js&"
import style0 from "./DesktopComponent.vue?vue&type=style&index=0&id=1beff330&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1beff330",
  null
  
)

export default component.exports